<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.v-application--wrap {
  font-family: "Muli" !important;
}
</style>
